import { useRouter } from "next/router";
import { CSSProperties, useContext, useEffect } from "react";
import CenteredSpinner from "../components/common/centered-spinner";
import { LayoutStateContext } from "../contexts/layout_state";
import { useCssStateManager } from "../hooks/use_css_state_manager";
import { useCustomRouter } from "../hooks/use_custom_router";
import { useSmartState } from "../hooks/use_smart_state";
import IframePage from "../lib/iframe_page";
import { prebuildData } from "../lib/prebuild-data";
import { libWindowMessages } from "../lib/windowmessages";

export async function getStaticPaths() {
    prebuildData.loadSnapshot();

    const { pageRoutes } = prebuildData.getGlobalConfig();
    const hash: {[path: string]: { params: { slug: string[]; } }} = {};
    pageRoutes.forEach((path) => {
        const slug: string[] = [];
        path.substring(1).split("/").forEach((part) => {
            slug.push(part);
            hash[`/${slug.join("/")}`] = {
                params: {
                    slug: [...slug]
                }
            };
        });
    });        
    return {
        paths: Object.keys(hash).map((path) => hash[path]),
        fallback: false
    };
}
  
export async function getStaticProps(context) {
    return {
        props: {},
    };
}

export type CatchAllProps = {
};

export default function CatchAll({}:CatchAllProps)
{
    const router = useCustomRouter();
    const { page } = useContext(LayoutStateContext);

    useEffect(() => {
        return router.beforePushSubscribe((cb) => {
            page.scrollToTopWithCallback(cb);
            return true;
        });
    },[]);

    const reactRouter = useRouter();    

    return (
        <>
            <div className="page-wrapper">Demo: this page has been disabled.</div>
            <style jsx>{`
            .page-wrapper {
                /* min-height: 600rem; */
                width: 100%;
                color: #333;
                padding: 50rem 40rem;
                padding-top: 50rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                flex-wrap: wrap;
            }
            .secure {

            }
            `}</style>
        </>
    );

    // return <IframePage key={reactRouter.asPath} slug={reactRouter.asPath} />;
}